// @flow
import * as React from 'react';
import { postJson } from 'utils/http';
import type { EmailCampaignSignupSingleBlockData } from 'api/cms';
import EmailCampaignSignup from './EmailCampaignSignup';

const { useState } = React;

type Mode = 'initial' | 'submitting' | 'submitted';

const EmailCampaignSignupSingleBlock = ({
  blockId,
  data: { headline, buttonText, bgImage },
  isSidebar
}: {
  blockId: string,
  data: EmailCampaignSignupSingleBlockData,
  isSidebar?: boolean
}) => {
  const [mode: Mode, setMode] = useState('initial');

  const onSubmit = ({
    values,
    handleError
  }: {
    values: Object,
    handleError: Function
  }) => {
    const postBaseUrl = isSidebar
      ? '/data/website/sidebar-email-signup-single/'
      : '/data/website/page-email-signup-single/';
    setMode('submitting');
    postJson(postBaseUrl + blockId, values)
      .then(() => {
        setMode('submitted');
      })
      .catch(e => {
        handleError(e);
        setMode('initial');
      });
  };

  return (
    <EmailCampaignSignup
      disabled={mode === 'submitting'}
      onSubmit={onSubmit}
      headline={headline}
      buttonText={buttonText}
      isSidebar={isSidebar}
      isSubmitted={mode === 'submitted'}
      bgImage={bgImage}
      qaId="cms-email-campaign-signup-single"
    />
  );
};

export default EmailCampaignSignupSingleBlock;
